// Libellés d'interface repris VERBATIM des docs officielles de chaque éditeur
// (en anglais, comme dans ces docs). Le lien « Docs officielles » reste la source
// de vérité car ces libellés évoluent régulièrement.
export default [
  {
    id: 'claude',
    logo: '/img/mcp-providers/claude.svg',
    name: 'Claude',
    surface: 'Web & Desktop',
    availability: 'Connecteur personnalisé',
    description: 'Ajoutez un connecteur MCP distant dans les réglages de Claude.',
    requirement: 'Disponible dès l’offre Gratuite (1 connecteur maximum). Gratuit, Pro et Max : chacun l’ajoute lui-même ; Team/Enterprise : un propriétaire le configure, puis les membres cliquent « Connecter ».',
    docsUrl: 'https://support.claude.com/en/articles/11175166-get-started-with-custom-connectors-using-remote-mcp',
    steps: [
      {
        action: 'Cliquez sur « + Ajouter », puis « Ajouter un connecteur personnalisé ».',
        path: 'Personnaliser › Connecteurs',
      },
      {
        action: 'Nommez-le, collez l’URL du serveur MCP distant, puis « Continuer ».',
        path: 'Ajouter un connecteur personnalisé',
        copy: '{{MCP_URL}}',
        copyLabel: 'l’URL MCP',
      },
      {
        action: 'Réglez l’« Authentification » (OAuth), puis « Ajouter ».',
        path: 'Authentification › Ajouter',
      },
    ],
  },
  {
    id: 'chatgpt',
    logo: '/img/mcp-providers/chatgpt.svg',
    name: 'ChatGPT',
    surface: 'Web',
    availability: 'Mode développeur',
    description: 'Ajoutez Teachizy comme connecteur MCP personnalisé via le mode développeur de ChatGPT.',
    requirement: 'Réservé à ChatGPT Business, Enterprise ou Edu (web) ; le mode développeur doit être activé par un administrateur.',
    docsUrl: 'https://help.openai.com/en/articles/12584461-developer-mode-and-mcp-apps-in-chatgpt',
    steps: [
      {
        action: 'Activez « Mode développeur ».',
        path: 'Paramètres › Apps › Paramètres avancés',
      },
      {
        action: 'Cliquez sur « Créer », renseignez le nom et l’URL (endpoint) de votre serveur MCP.',
        path: 'Apps › Créer',
        copy: '{{MCP_URL}}',
        copyLabel: 'l’URL MCP',
      },
      {
        action: 'Terminez l’OAuth ; l’app apparaît dans vos Apps et devient sélectionnable en conversation.',
        path: 'Paramètres › Apps',
      },
    ],
  },
  {
    id: 'gemini',
    logo: '/img/mcp-providers/gemini.svg',
    name: 'Gemini',
    surface: 'Web & Mobile',
    availability: 'Custom app',
    description: 'Ajoutez Teachizy comme application personnalisée depuis les réglages de Gemini.',
    requirement: 'Disponible en anglais aux États-Unis, avec un compte Google personnel 18+ et l’activité Gemini activée.',
    docsUrl: 'https://support.google.com/gemini/answer/17209137',
    steps: [
      {
        action: 'Ouvrez « Connected Apps », puis « Add a custom app ».',
        path: 'Settings › Connected Apps › Custom apps',
      },
      {
        action: 'Collez l’URL MCP, puis « Next ».',
        path: 'Add a custom app',
        copy: '{{MCP_URL}}',
        copyLabel: 'l’URL MCP',
      },
      {
        action: 'Terminez l’autorisation, puis tapez « @ » et choisissez votre app dans le chat.',
        path: 'Chat › @ › votre app',
      },
    ],
  },
  {
    id: 'mistral',
    logo: '/img/mcp-providers/mistral.svg',
    name: 'Le Chat (Mistral)',
    surface: 'Le Chat / Vibe',
    availability: 'Connecteur MCP',
    description: 'Ajoutez Teachizy aux connecteurs personnalisés de l’assistant Mistral.',
    requirement: 'L’ajout d’un connecteur personnalisé est réservé à l’administrateur de l’espace ; sur les offres Gratuit, Pro et Student, le propriétaire du compte l’est par défaut.',
    docsUrl: 'https://docs.mistral.ai/vibe/work/connectors/mcp-connectors',
    steps: [
      {
        action: 'Cliquez sur « + Add Connector », puis l’onglet « Custom MCP Connector ».',
        path: 'Connectors',
      },
      {
        action: 'Renseignez « Connector name », collez l’URL dans « Server URL », puis « Connect ».',
        path: 'Custom MCP Connector',
        copy: '{{MCP_URL}}',
        copyLabel: 'l’URL MCP',
      },
      {
        action: 'Suivez le flux d’authentification détecté automatiquement (OAuth), puis validez.',
        path: 'Authentification automatique',
      },
    ],
  },
  {
    id: 'grok',
    logo: '/img/mcp-providers/grok.svg',
    name: 'Grok',
    surface: 'Web',
    availability: 'Connecteur personnalisé',
    description: 'Ajoutez Teachizy depuis le catalogue de connecteurs de Grok.',
    requirement: 'Le serveur MCP doit être accessible publiquement sur Internet ; disponibilité selon votre compte Grok.',
    docsUrl: 'https://docs.x.ai/grok/connectors',
    steps: [
      {
        action: 'Cliquez sur « New Connector ».',
        path: 'grok.com › Connectors',
      },
      {
        action: 'Choisissez « Custom », puis collez l’URL de votre serveur MCP.',
        path: 'New Connector › Custom',
        copy: '{{MCP_URL}}',
        copyLabel: 'l’URL MCP',
      },
      {
        action: 'Terminez l’authentification requise par votre serveur MCP.',
        path: 'Authentification',
      },
    ],
  },
];
